<template>
  <MembershipPage title="Your Membership">
    <template #aboveBox>
      <PlanCard
        v-if="currentPlan?.id"
        :plan-id="currentPlan.id"
        :selectable="false"
        :force-selected="true"
        :tag-line="tagLine"
        class="mx-auto"
        :style="{ '--plan-card-min-width': '350px' }"/>
    </template>
    <template #belowBox>
      <div class="d-flex flex-column">
        <ActionButton
          :to="{ name: 'change-plan' }"
          text="Change Plan"/>
        <ActionButton
          :to="{ name: 'change-plan' }"
          text="Prepay + Save up to $600"/>
        <ActionButton
          v-if="clientIsPaused"
          :to="{ name: 'resume' }"
          text="Resume Membership"/>
        <ActionButton
          v-if="clientIsPaused"
          :to="{ name: 'cancel-benefits' }"
          text="Extend Pause"/>
        <ActionButton
          v-else-if="!clientIsPaused"
          :to="pausePage"
          text="Pause or Cancel Membership"/>
      </div>
    </template>
  </MembershipPage>
</template>

<script setup>
import MembershipPage from '@/components/account/membership/new/MembershipPage.vue'
import ActionButton from '@shared/components/ADORN/buttons/ActionButton.vue'
import PlanCard from '@shared/components/ADORN/planCard/PlanCard.vue'
import { useClientStore } from '@shared/stores/client.js'
import { storeToRefs } from 'pinia'
import { computed, onMounted } from 'vue'
import { usePlanSelection } from '@shared/composables/planSelection.js'
import { usePlans } from '@shared/composables/plans.js'
import { usePauseCancel } from '@/composables/pauseCancel.js'
import useAnalytics from '@shared/composables/analytics.js'

const { membershipDetails } = storeToRefs(useClientStore())
const { clientIsPaused } = usePauseCancel()
const { initializeMembershipPlans } = usePlans()
const { currentPlan } = usePlanSelection()
const { trackPageViewEvent } = useAnalytics()

const pausePage = computed(() => {
  return clientIsPaused.value || membershipDetails.value?.pauseDate ? { name: 'cancel-benefits' } : { name: 'pause-or-cancel' }
})

const tagLine = computed(() => {
  return currentPlan.value.tagLine || 'Current'
})

onMounted(() => {
  trackPageViewEvent('Membership Overview')
  initializeMembershipPlans()
})
</script>